import ambassadorHOC from "../../ambassador-hoc";
import {
  MeetingRecordingsView,
  PdfScopeBlock,
} from "../../../../components/shared";
import { convertToFullName } from "../../../../services/utils";

function ambassadorPdfScope(ambassadorDetails: any): PdfScopeBlock | undefined {
  if (!ambassadorDetails) return undefined;
  const company = (ambassadorDetails.company || "").trim();
  const name = convertToFullName(
    ambassadorDetails.firstName,
    ambassadorDetails.lastName
  ).trim();
  const title = (ambassadorDetails.title || "").trim();
  if (!company && !name) return undefined;

  if (name) {
    return {
      primary: name,
      secondary: title || undefined,
      tertiary: company || undefined,
    };
  }

  return {
    primary: company,
    secondary: title || undefined,
  };
}

function AmbassadorMeetingRecordings({ ambassadorDetails }: any) {
  return (
    <MeetingRecordingsView
      lockedAmbassadorId={ambassadorDetails?.id}
      pdfScope={ambassadorPdfScope(ambassadorDetails)}
    />
  );
}

export default ambassadorHOC(AmbassadorMeetingRecordings);
